import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectSummariesForCurrentBib, selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { catalogBibShape, ugcSummaryShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentUserSummaries, selectSummariesTransactions } from 'app/selectors/ugc/SummariesSelector';
import BibsActions from 'app/actions/BibsActions';
import Summaries from './Summaries';

export class SummariesContainer extends React.PureComponent {
  render() {
    return <Summaries {...this.props} />;
  }
}

SummariesContainer.propTypes = {
  summaries: ImmutablePropTypes.list.isRequired,
  currentUserSummaries: ImmutablePropTypes.mapOf(ugcSummaryShape),
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  summary: ImmutablePropTypes.map,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  catalogBib: catalogBibShape.isRequired
};

const mapStateToProps = state => ({
  summaries: selectSummariesForCurrentBib(state),
  summary: selectUgcSummary(state),
  summariesTransactions: selectSummariesTransactions(state),
  currentUserSummaries: selectCurrentUserSummaries(state),
  catalogBib: selectCatalogBib(state)
});

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SummariesContainer);
